import { apiClient } from './authService';

const permissionsAdminService = {
  /**
   * Récupère toutes les permissions groupées par rôle
   */
  getPermissionsByRole: async () => {
    const response = await apiClient.get('/permissions-admin/by_role/');
    return response.data;
  },

  /**
   * Récupère toutes les permissions avec filtres optionnels
   */
  getAll: async (params = {}) => {
    const response = await apiClient.get('/permissions-admin/', { params });
    return response.data;
  },

  /**
   * Met à jour une permission
   */
  update: async (id, data) => {
    const response = await apiClient.patch(`/permissions-admin/${id}/`, data);
    return response.data;
  },

  /**
   * Met à jour plusieurs permissions en une fois
   */
  bulkUpdate: async (updates) => {
    const response = await apiClient.post('/permissions-admin/bulk_update/', {
      updates
    });
    return response.data;
  },

  /**
   * Récupère la liste des ressources disponibles
   */
  getResources: async () => {
    const response = await apiClient.get('/permissions-admin/resources/');
    return response.data;
  },

  /**
   * Récupère la liste des actions disponibles
   */
  getActions: async () => {
    const response = await apiClient.get('/permissions-admin/actions/');
    return response.data;
  }
};

export default permissionsAdminService;
